module.exports = __webpack_public_path__ + "img/398.e6632f82.png";